import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Indicator, Tooltip } from './styled';

// TODO: Use this component for all statuse

const Status = ({ label, description, color, variant = 'light', className }) => {
  return (
    <Wrapper className={className}>
      <Indicator $color={color} variant={variant}>
        {description && <Tooltip>{description}</Tooltip>}
      </Indicator>
      {label && <span>{label}</span>}
    </Wrapper>
  );
};

Status.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  variant: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string
};

export default Status;
